import {
  Autocomplete,
  FormLabel,
  FormHelperText,
  TextField,
  Typography,
  FormControlLabel,
  Box,
  Button,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "@mui/material/Select";
import "../../style/css/eventForm.css";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import { toast } from "react-toastify";
import Spinner from "../../Component/spinner/spinner";
import { EligibilityExaminations, ProfessionalDevelopment, InterdisciplinaryAreas, EnglishLanguageTeaching, Linguistics, LiteraryStudies, OTHER_QUALIFICATIONS, Salutation, Qualifications } from '../../constant/constant'
import { Country, State } from 'country-state-city';
import { useLazyGetMemberDetailsByIdQuery, useUpdateMemberMutation } from '../../app/services/memberServices'
import { selectCurrentScope } from "../../app/auth/authSlice";
import { useSelector, useDispatch } from "react-redux";
import { setMemberDetails } from '../../app/features/memberSlice'
import { useParams, useNavigate } from "react-router-dom";

function Profile() {
  const [showStudyingOtherInput, setShowStudyingOtherInput] = useState(false);
  const [showEligibilityOtherInput, setShowEligibilityOtherInput] = useState(false);
  const [showProfessionOtherInput, setShowProfessionOtherInput] = useState(false);
  const [showLiteraryOtherInput, setShowLiteraryOtherInput] = useState(false);
  const [showLinguisticsOtherInput, setShowLinguisticsOtherInput] = useState(false);
  const [showELTOtherInput, setShowELTOtherInput] = useState(false);
  const [showInterOtherInput, setShowInterOtherInput] = useState(false);
  const navigate = useNavigate()
  const memberScope = useSelector(selectCurrentScope);

  //Student Contact Details
  /* ========================= */
  const [loading, setLoading] = useState(false);
  // const userId= useSelector(selectUserId);
  const [gettMemberDetailsByIdQuery] = useLazyGetMemberDetailsByIdQuery();
  const [updateMember] = useUpdateMemberMutation();
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [getStudentDetails, setGetStudentDetails] = useState()
  const dispatch = useDispatch()
  const { key } = useParams();
  const { id } = useParams();
  // useForm hook for form data handling
  const {
    control: controlContact,
    register: registerContact,
    handleSubmit: handleSubmitContact,
    setValue: setValueContact,
    formState: { errors: errorsContact },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      type: '1',
      address: "",
      city: "",
      pinCode: "",
      state: "",
      country: "",
      mobileNumber: '',
      whatsAppNumber: '',
      email: "",
      landlineNumber: '',
      contactInformation: "",
      role: "PORTAL_MEMBER",
    },
  });

  const countries = Country.getAllCountries();
  const states = selectedCountry ? State.getStatesOfCountry(selectedCountry) : [];

  // Update states whenever selectedCountry changes
  useEffect(() => {
    if (selectedCountry) {
      const fetchedStates = State.getStatesOfCountry(selectedCountry);
      setSelectedState(fetchedStates);
      // If we have getStudentDetails, set the state based on it
      if (getStudentDetails?.state) {
        setValueContact("state", getStudentDetails.state);
        setSelectedState(getStudentDetails.state); // Set the selected state
      } else {
        setValueContact("state", ""); // Reset state if no state exists
      }
    }
  }, [selectedCountry, setValueContact, getStudentDetails]);

  useEffect(() => {
    gettMemberDetailsByIdQuery(id).then((res) => {
      if (res?.data?.status) {
        setGetStudentDetails(res?.data?.data)
      }
    })
  }, [gettMemberDetailsByIdQuery, id])

  useEffect(() => {
  }, [getStudentDetails])

  useEffect(() => {
    if (getStudentDetails) {
      const countryName = getStudentDetails.country; // Example country name
      const countryData = Country.getAllCountries().find(
        (c) => c.name.toLowerCase() === countryName.toLowerCase()
      );

      setValueContact("address", getStudentDetails.address)
      setValueContact("city", getStudentDetails.city)
      setValueContact("pinCode", getStudentDetails.pinCode)
      // setValueContact("country", getStudentDetails.country)
      // setSelectedCountry(getStudentDetails.country);
      setValueContact("country", countryData?.isoCode)
      setSelectedCountry(countryData?.isoCode)
      setValueContact("mobileNumber", getStudentDetails.mobileNumber)
      setValueContact("whatsAppNumber", getStudentDetails.whatsAppNumber)
      setValueContact("email", getStudentDetails.email)
      setValueContact("landlineNumber", getStudentDetails.landlineNumber)
      setValueContact("contactInformation", getStudentDetails.contactInformation)
    }
  }, [getStudentDetails, setValueContact])

  //On submit for update
  const UpdateStudentMemberContact = (data, id) => {
    setLoading(false)
    const formData = new FormData();
    // Iterate over the keys and values of the data object
    Object.entries(data).forEach(([key, value]) => {
      if (key !== 'contactInformation' && value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    if (data.contactInformation && data.contactInformation.length > 0) {
      data.contactInformation.forEach(item => {
        formData.append("contactInformation", item)
      })
    }
    const updateData = { id: id, formData }
    updateMember(updateData).then((res) => {
      if (res?.data?.data) {
        toast.success(res?.data?.message);
        if (memberScope === "PORTAL_MEMBER") {
          navigate(`/member/student-member/${id}`)
        } else {
          navigate(`/admin/student-member/${id}`)
        }
        gettMemberDetailsByIdQuery(id).then((res) => {
          if (res?.data?.status) {
            dispatch(setMemberDetails(res?.data?.data))
          }
        })
      }
      else {
        toast.error(res?.data?.err?.message);
      }
    }).catch((err) => {
      console.error(err)
    })
  }

  /*basic*/

  const {
    control: BasicContact,
    register: registerBasic,
    handleSubmit: handleSubmitBasic,
    setValue: setValueBasic,
    formState: { errors: errorsBasic },
    watch
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      // type: '0',
      fullName: '',
      dateOfBirth: '',
      salutation: '',
      gender: '',
      role: "PORTAL_MEMBER",
    },
  });
  useEffect(() => {
    if (getStudentDetails) {
      const fieldsToUpdate = {
        fullName: getStudentDetails.fullName,
        dateOfBirth: getStudentDetails.dateOfBirth,
        salutation: getStudentDetails.salutation,
        gender: getStudentDetails.gender,
      };

      // Update form fields in one loop
      Object.entries(fieldsToUpdate).forEach(([key, value]) => {
        setValueBasic(key, value);
      });

      // Handle country separately if needed elsewher
    }
  }, [getStudentDetails, setValueBasic]);
  const UpdateTeachersMemberBasic = (data, id) => {
    setLoading(false)
    const formData = new FormData();
    // Iterate over the keys and values of the data object
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    const updateData = { id: id, formData }
    updateMember(updateData).then((res) => {
      if (res?.data?.data) {
        toast.success(res?.data?.message);
        if (memberScope === "PORTAL_MEMBER") {
          navigate(`/member/student-member/${id}`)
        } else {
          navigate(`/admin/student-member/${id}`)
        }

        gettMemberDetailsByIdQuery(id).then((res) => {
          if (res?.data?.status) {
            dispatch(setMemberDetails(res?.data?.data))
          }
        })
      }
      else {
        toast.error(res?.data?.err?.message);
      }
    }).catch((err) => {
      console.error(err)
    })
  }
  //Student Academic Profile Links
  /* ========================= */

  // useForm hook for form data handling
  const {
    control: controlAcademic,
    register: registerAcademic,
    handleSubmit: handleSubmitAcademic,
    setValue: setValueAcademic,
    formState: { errors: errorsAcademic },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      type: '1',
      scholarProfile: "",
      scopusProfileLink: "",
      ORICID: "",
      linkedInProfile: "",
      blog: "",
      youtubeChannel: '',
      shareInformation: '0',
      role: "PORTAL_MEMBER",
    },
  });

  useEffect(() => {
    gettMemberDetailsByIdQuery(id).then((res) => {
      if (res?.data?.status) {
        setGetStudentDetails(res?.data?.data)
      }
    })
  }, [gettMemberDetailsByIdQuery, id])

  useEffect(() => {
  }, [getStudentDetails])

  useEffect(() => {
    if (getStudentDetails) {
      setValueAcademic("scholarProfile", getStudentDetails.scholarProfile)
      setValueAcademic("scopusProfileLink", getStudentDetails.scopusProfileLink)
      setValueAcademic("ORICID", getStudentDetails.ORICID)
      setValueAcademic("linkedInProfile", getStudentDetails.linkedInProfile)
      setValueAcademic("blog", getStudentDetails.blog)
      setValueAcademic("youtubeChannel", getStudentDetails.youtubeChannel)
      setValueAcademic("shareInformation", getStudentDetails.shareInformation)
    }
  }, [getStudentDetails, setValueAcademic])

  //On submit for update
  const UpdateStudentMemberAcademic = (data, id) => {
    setLoading(false)
    const formData = new FormData();
    // Iterate over the keys and values of the data object
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    const updateData = { id: id, formData }
    updateMember(updateData).then((res) => {
      if (res?.data?.data) {
        toast.success(res?.data?.message);
        if (memberScope === "PORTAL_MEMBER") {
          navigate(`/member/student-member/${id}`)
        } else {
          navigate(`/admin/student-member/${id}`)
        }
        if (res.data.status) {
          gettMemberDetailsByIdQuery(id).then((res) => {
            if (res?.data?.status) {
              dispatch(setMemberDetails(res?.data?.data))
            }
          })
        }
      }
      else {
        toast.error(res?.data?.err?.message);
      }
    }).catch((err) => {
      console.error(err)
    })
  }

  //Student Educational Details
  /* ========================= */

  const [otherStudying, setOtherStudying] = useState('');
  const [otherEligibility, setOtherEligibility] = useState('');

  // useForm hook for form data handling
  const {
    control: controlEducation,
    register: registerEducation,
    handleSubmit: handleSubmitEducation,
    setValue: setValueEducation,
    formState: { errors: errorsEducation },

  } = useForm({
    mode: 'onChange',
    defaultValues: {
      type: '1',
      studying: "",
      otherStudying: "",
      eligibilityExamination: "",
      institution: "",
      institutionCity: "",
      role: "PORTAL_MEMBER",
    },
  });

  const eligibilityOptions = useMemo(() => EligibilityExaminations.map(exam => exam.name), []);

  // Memoizing the options arrays
  const memoizedEligibilityOptions = useMemo(() => eligibilityOptions, [eligibilityOptions]);

  //Get all member details
  const getMemberDetails = useCallback(
    () => {
      gettMemberDetailsByIdQuery(id).then((res) => {
        if (res?.data?.status) {
          const studentDetails = res?.data?.data;
          setGetStudentDetails(studentDetails);

          const studying = studentDetails?.studying;
          const isOtherStudying = studying === OTHER_QUALIFICATIONS ? true : false;
          setOtherStudying(isOtherStudying ? studentDetails?.otherStudying : '');
          setShowStudyingOtherInput(isOtherStudying);

          const eligibilityExams = studentDetails?.eligibilityExamination || [];
          const otherText = eligibilityExams.find(item => !memoizedEligibilityOptions.includes(item));
          setOtherEligibility(otherText || '');
          setShowEligibilityOtherInput(!!otherText);

          setValueEducation('otherEligibility', otherText);
        }
      });
    }, [gettMemberDetailsByIdQuery, id, memoizedEligibilityOptions, setValueEducation]
  )

  //getAllNews
  useEffect(() => {
    getMemberDetails()
  }, [getMemberDetails])

  const handleOtherEligibilityChange = (e) => {
    const inputValue = e.target.value;
    setOtherEligibility(inputValue);
    if (inputValue && !eligibilityOptions.includes(inputValue)) {
      setShowEligibilityOtherInput(true);
    }
  };

  useEffect(() => {
  }, [getStudentDetails])

  useEffect(() => {
    if (getStudentDetails) {
      setValueEducation("studying", getStudentDetails.studying)
      setValueEducation("otherStudying", getStudentDetails.otherStudying)
      setValueEducation("eligibilityExamination", getStudentDetails.eligibilityExamination)
      setValueEducation("institution", getStudentDetails.institution)
      setValueEducation("institutionCity", getStudentDetails.institutionCity)
    }
  }, [getStudentDetails, setValueEducation])

  //On submit for update
  const UpdateStudentMemberEducation = (data, id) => {
    setLoading(false)
    const formData = new FormData();
    // Iterate over the keys and values of the data object
    Object.entries(data).forEach(([key, value]) => {
      if (key !== 'eligibilityExamination' && key !== 'otherEligibility' && key !== 'studying' && key !== 'otherInputValue' && key !== "otherStudying" && value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    let updatedEligibilityExams = [...data.eligibilityExamination];
    const otherInputIndex = updatedEligibilityExams.findIndex(value => value === 'Other')
    const otherEligibilityText = updatedEligibilityExams.filter(v => !memoizedEligibilityOptions.find(d => d === v)).filter(v => v !== otherEligibility)
    if (otherInputIndex !== -1 && otherEligibility && !updatedEligibilityExams.includes(otherEligibility)) {
      formData.append("eligibilityExamination", otherEligibility); // Ensure this is appended correctly
    }
    const updatedEligiblity = updatedEligibilityExams.filter(item => item.trim() !== "")
    if (updatedEligiblity.length > 0) {
      updatedEligiblity.forEach(item => {
        if (!otherEligibilityText.includes(item)) {
          formData.append("eligibilityExamination", item);
        }
      });
    }
    else {
      formData.append("eligibilityExamination", []);
    }

    // Handle studying and otherStudying
    const { studying } = data;
    formData.append("studying", studying);
    if (showStudyingOtherInput && otherStudying) {
      formData.append("otherStudying", otherStudying);
    } else {
      formData.append("otherStudying", "");
    }

    const updateData = { id: id, formData }
    updateMember(updateData).then((res) => {
      if (res?.data?.data) {
        toast.success(res?.data?.message);
        if (memberScope === "PORTAL_MEMBER") {
          navigate(`/member/student-member/${id}`)
        } else {
          navigate(`/admin/student-member/${id}`)
        }
        gettMemberDetailsByIdQuery(id).then((res) => {
          if (res?.data?.status) {
            dispatch(setMemberDetails(res?.data?.data))
          }
        })
      }
      else {
        toast.error(res?.data?.err?.message);
      }
    }).catch((err) => {
      console.error(err)
    })
  }

  //Student Professional Development
  /* ========================= */

  const [otherProfession, setOtherProfession] = useState('');
  const [otherLit, setOtherLit] = useState('');
  const [otherLing, setOtherLing] = useState('');
  const [otherELT, setOtherELT] = useState('');
  const [otherInter, setOtherInter] = useState('');

  // useForm hook for form data handling
  const {
    control: controlProfession,
    register: registerProfession,
    handleSubmit: handleSubmitProfession,
    setValue: setValueProfession,
    watch: watchProfession,
    formState: { errors: errorsProfession },
    trigger
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      type: '1',
      teacherAssociation: "",
      associationName: "",
      professionalDevelopment: "",
      expertiseLiteraryStudies: "",
      expertiseLinguistics: "",
      expertiseELT: "",
      expertiseInterdisciplinaryAreas: "",
      areaOfExpertise: "0",
      role: "PORTAL_MEMBER",
    },
  });

  const professionOptions = useMemo(() => ProfessionalDevelopment.map(exam => exam.name), []);
  const litOptions = useMemo(() => LiteraryStudies.map(exam => exam.name), []);
  const lingOptions = useMemo(() => Linguistics.map(exam => exam.name), []);
  const ELTOptions = useMemo(() => EnglishLanguageTeaching.map(exam => exam.name), []);
  const interOptions = useMemo(() => InterdisciplinaryAreas.map(exam => exam.name), []);

  // Memoizing the options arrays
  const memoizedProfessionOptions = useMemo(() => professionOptions, [professionOptions]);
  const memoizedLitOptions = useMemo(() => litOptions, [litOptions]);
  const memoizedLingOptions = useMemo(() => lingOptions, [lingOptions]);
  const memoizedELTOptions = useMemo(() => ELTOptions, [ELTOptions]);
  const memoizedInterOptions = useMemo(() => interOptions, [interOptions]);

  const getMemberDetailsById = useCallback(() => {
    gettMemberDetailsByIdQuery(id).then((res) => {
      if (res?.data?.status) {
        const studentDetails = res?.data?.data;
        setGetStudentDetails(studentDetails);

        const professionExams = studentDetails?.professionalDevelopment || [];
        const otherText = professionExams.find(item => !memoizedProfessionOptions.includes(item));
        setOtherProfession(otherText || '');
        setShowProfessionOtherInput(!!otherText);

        setValueProfession('otherProfession', otherText);

        const LitExams = studentDetails?.expertiseLiteraryStudies || [];
        const otherLitText = LitExams.find(item => !memoizedLitOptions.includes(item));
        setOtherLit(otherLitText || '');
        setShowLiteraryOtherInput(!!otherLitText);

        setValueProfession('otherLit', otherLitText);

        const LingExams = studentDetails?.expertiseLinguistics || [];
        const otherLingText = LingExams.find(item => !memoizedLingOptions.includes(item));
        setOtherLing(otherLingText || '');
        setShowLinguisticsOtherInput(!!otherLingText);

        setValueProfession('otherLing', otherLingText);

        const ELTExams = studentDetails?.expertiseELT || [];
        const otherELTText = ELTExams.find(item => !memoizedELTOptions.includes(item));
        setOtherELT(otherELTText || '');
        setShowELTOtherInput(!!otherELTText);

        setValueProfession('otherELT', otherELTText);

        const interExams = studentDetails?.expertiseInterdisciplinaryAreas || [];
        const otherInterText = interExams.find(item => !memoizedInterOptions.includes(item));
        setOtherInter(otherInterText || '');
        setShowInterOtherInput(!!otherInterText);

        setValueProfession('otherInter', otherInterText);
      }
    });
  }, [gettMemberDetailsByIdQuery, id, memoizedProfessionOptions, memoizedLitOptions, memoizedLingOptions, memoizedELTOptions, memoizedInterOptions, setValueProfession])

  //Get member details by id
  useEffect(() => {
    getMemberDetailsById()
  }, [getMemberDetailsById])

  const handleOtherProfessionChange = (e) => {
    const inputValue = e.target.value;
    setOtherProfession(inputValue);
    if (inputValue && !professionOptions.includes(inputValue)) {
      setShowProfessionOtherInput(true);
    }
  };

  const handleOtherLitChange = (e) => {
    const inputValue = e.target.value;
    setOtherLit(inputValue);
    if (inputValue && !litOptions.includes(inputValue)) {
      setShowLiteraryOtherInput(true);
    }
  };

  const handleOtherLingChange = (e) => {
    const inputValue = e.target.value;
    setOtherLing(inputValue);
    if (inputValue && !lingOptions.includes(inputValue)) {
      setShowLinguisticsOtherInput(true);
    }
  };

  const handleOtherELTChange = (e) => {
    const inputValue = e.target.value;
    setOtherELT(inputValue);
    if (inputValue && !ELTOptions.includes(inputValue)) {
      setShowELTOtherInput(true);
    }
  };

  const handleOtherInterChange = (e) => {
    const inputValue = e.target.value;
    setOtherInter(inputValue);
    if (inputValue && !interOptions.includes(inputValue)) {
      setShowInterOtherInput(true);
    }
  };

  useEffect(() => {
  }, [getStudentDetails])

  useEffect(() => {
    if (getStudentDetails) {
      setValueProfession("teacherAssociation", getStudentDetails.teacherAssociation ?? '0')
      if (getStudentDetails.teacherAssociation === 1) {
        trigger("associationName"); // Ensure validation is triggered when editing if "Yes" is selected
      }
      setValueProfession("associationName", getStudentDetails.associationName)
      setValueProfession("professionalDevelopment", getStudentDetails.professionalDevelopment)
      setValueProfession("expertiseLiteraryStudies", getStudentDetails.expertiseLiteraryStudies)
      setValueProfession("expertiseLinguistics", getStudentDetails.expertiseLinguistics)
      setValueProfession("expertiseELT", getStudentDetails.expertiseELT)
      setValueProfession("expertiseInterdisciplinaryAreas", getStudentDetails.expertiseInterdisciplinaryAreas)
      setValueProfession("areaOfExpertise", getStudentDetails.areaOfExpertise)
    }
  }, [getStudentDetails, setValueProfession, trigger])

  // Watch the value of the radio group
  const isTeachersAsso = watchProfession("teacherAssociation");

  // Automatically trigger validation on associationName when teacherAssociation changes
  useEffect(() => {
    if (isTeachersAsso === 1) {
      trigger("associationName"); // Trigger validation for associationName
    } else if (isTeachersAsso === 0) {
      setValueProfession("associationName", ""); // Clear the associationName field when "No" is selected
    }
  }, [isTeachersAsso, trigger, setValueProfession]);

  //On submit for update
  const UpdateStudentMemberProfession = (data, id) => {
    const formData = new FormData();
    // Iterate over the keys and values of the data object
    Object.entries(data).forEach(([key, value]) => {
      if (key !== 'professionalDevelopment' && key !== 'expertiseLiteraryStudies' && key !== 'expertiseLinguistics' && key !== 'expertiseELT' && key !== 'expertiseInterdisciplinaryAreas' && key !== 'otherProfession' && key !== 'otherLit' && key !== 'otherLing' && key !== 'otherELT' && key !== 'otherInter' && value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    let updatedProfessionExams = [...data.professionalDevelopment];
    const otherInputIndex = updatedProfessionExams.findIndex(value => value === 'Other')
    const otherProfessionText = updatedProfessionExams.filter(v => !memoizedProfessionOptions.find(d => d === v)).filter(v => v !== otherProfession)
    if (otherInputIndex !== -1 && otherProfession && !updatedProfessionExams.includes(otherProfession)) {
      formData.append("professionalDevelopment", otherProfession); // Ensure this is appended correctly
    }
    const updatedProfessionEx = updatedProfessionExams.filter(item => item.trim() !== "")
    if (updatedProfessionEx.length > 0) {
      updatedProfessionEx.forEach(item => {
        if (!otherProfessionText.includes(item)) {
          formData.append("professionalDevelopment", item);
        }
      });
    }
    else {
      formData.append("professionalDevelopment", [""]);
    }

    let updatedLitExams = [...data.expertiseLiteraryStudies];
    const otherInputLitIndex = updatedLitExams.findIndex(value => value === 'Other')
    const otherLitText = updatedLitExams.filter(v => !memoizedLitOptions.find(d => d === v)).filter(v => v !== otherLit)
    if (otherInputLitIndex !== -1 && otherLit && !updatedLitExams.includes(otherLit)) {
      formData.append("expertiseLiteraryStudies", otherLit); // Ensure this is appended correctly
    }
    const updatedLit = updatedLitExams.filter(item => item.trim() !== "")
    if (updatedLit.length > 0) {
      updatedLit.forEach(item => {
        if (!otherLitText.includes(item)) {
          formData.append("expertiseLiteraryStudies", item);
        }
      });
    }
    else {
      formData.append("expertiseLiteraryStudies", ['']);
    }

    let updatedLingExams = [...data.expertiseLinguistics];
    const otherInputLingIndex = updatedLingExams.findIndex(value => value === 'Other')
    const otherLingText = updatedLingExams.filter(v => !memoizedLingOptions.find(d => d === v)).filter(v => v !== otherLing)
    if (otherInputLingIndex !== -1 && otherLing && !updatedLingExams.includes(otherLing)) {
      formData.append("expertiseLinguistics", otherLing); // Ensure this is appended correctly
    }
    const updatedLing = updatedLingExams.filter(item => item.trim() !== "")
    if (updatedLing.length > 0) {
      updatedLing.forEach(item => {
        if (!otherLingText.includes(item)) {
          formData.append("expertiseLinguistics", item);
        }
      });
    }
    else {
      formData.append("expertiseLinguistics", ['']);
    }

    let updatedELTExams = [...data.expertiseELT];
    const otherInputELTIndex = updatedELTExams.findIndex(value => value === 'Other')
    const otherELTText = updatedELTExams.filter(v => !memoizedELTOptions.find(d => d === v)).filter(v => v !== otherELT)
    if (otherInputELTIndex !== -1 && otherELT && !updatedELTExams.includes(otherELT)) {
      formData.append("expertiseELT", otherELT); // Ensure this is appended correctly
    }
    const updatedELT = updatedELTExams.filter(item => item.trim() !== "")
    if (updatedELT.length > 0) {
      updatedELT.forEach(item => {
        if (!otherELTText.includes(item)) {
          formData.append("expertiseELT", item);
        }
      });
    }
    else {
      formData.append("expertiseELT", ['']);
    }

    let updatedInterExams = [...data.expertiseInterdisciplinaryAreas];
    const otherInputInterIndex = updatedInterExams.findIndex(value => value === 'Other')
    const otherInterText = updatedProfessionExams.filter(v => !memoizedProfessionOptions.find(d => d === v)).filter(v => v !== otherInter)
    if (otherInputInterIndex !== -1 && otherInter && !updatedProfessionExams.includes(otherInter)) {
      formData.append("expertiseInterdisciplinaryAreas", otherInter); // Ensure this is appended correctly
    }
    const updatedInter = updatedInterExams.filter(item => item.trim() !== "")
    if (updatedInter.length > 0) {
      updatedELT.forEach(item => {
        if (!otherInterText.includes(item)) {
          formData.append("expertiseInterdisciplinaryAreas", item);
        }
      });
    }
    else {
      formData.append("expertiseInterdisciplinaryAreas", ['']);
    }

    const updateData = { id: id, formData }
    updateMember(updateData).then((res) => {
      if (res?.data?.data) {
        toast.success(res?.data?.message);
        if (memberScope === "PORTAL_MEMBER") {
          navigate(`/member/student-member/${id}`)
        } else {
          navigate(`/admin/student-member/${id}`)
        }
        gettMemberDetailsByIdQuery(id).then((res) => {
          if (res?.data?.status) {
            dispatch(setMemberDetails(res?.data?.data))
          }
        })
      }
      else {
        toast.error(res?.data?.err?.message);
      }
    }).catch((err) => {
      console.error(err)
    })
  }

  return (
    <>

      {/* basic Details*/}
      {key === "basic" && (
        <Box>
          <div className="pt-1 pb-3">
            <div className="p-0">
              <div className="Architects-header d-flex align-items-center justify-content-center">
                <h2 className="title-font text-center">Basic Details</h2>
              </div>
            </div>
          </div>
          <div className="p-md-5 p-3 overallPadding">
            <div className="text-end mb-3">
              <Button
                onClick={() => window.history.back()}
                variant="contained"
                className="menus-color"
              >
                Back
              </Button>
            </div>
            {loading ? (
              <Spinner />
            ) : (
              <form
                className="mt-2"
                onSubmit={handleSubmitBasic((data) => UpdateTeachersMemberBasic(data, id))}
              >
                <Grid container rowSpacing={3} columnSpacing={2}>
                  <Grid item lg={4} md={6} xs={12}>
                    <Controller
                      control={BasicContact}
                      rules={{ required: "Please select an option" }}
                      name="salutation"
                      render={({ field, fieldState }) => (
                        <FormControl fullWidth>
                          <InputLabel className="text-dark" id="Salutation">
                            Salutation<span style={{ color: "red" }}>*</span>
                          </InputLabel>
                          <Select
                            className="bg-white"
                            labelId="Salutation"
                            id="Salutation"
                            label={
                              <Typography className="text-dark">
                                Salutation
                                <span style={{ color: "red" }}>*</span>
                              </Typography>
                            }
                            value={field.value === "" ? "" : field.value}
                            variant="outlined"
                            onChange={(e) => field.onChange(e.target.value)}
                            error={!!fieldState.error}
                          >
                            {Salutation.map((data) => (
                              <MenuItem key={data.Name} value={data.id}>
                                {data.Name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid item lg={4} md={6} xs={12}>
                    <TextField
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      label={
                        <Typography className="text-dark">
                          Your Full Name<span style={{ color: "red" }}>*</span>
                        </Typography>
                      }

                      {...registerBasic("fullName", {
                        required: "Please enter a full name",
                        minLength: {
                          value: 3,
                          message: "Please enter a valid name",
                        },
                      })}
                      error={!!errorsBasic?.fullName}
                      helperText={errorsBasic?.fullName?.message}
                      placeholder="Your Full Name"
                    />
                  </Grid>
                  <Grid item lg={4} md={6} xs={12}>
                    <TextField
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      label={
                        <Typography className="text-dark">
                          Your Date of Birth
                          <span style={{ color: "red" }}>*</span>
                        </Typography>
                      }
                      variant="outlined"
                      type="date"
                      value={
                        watch("dateOfBirth")
                          ? watch("dateOfBirth").split("T")[0]
                          : ""
                      }
                      {...registerBasic("dateOfBirth", {
                        required: "Please select your date of birth",
                        max: {
                          value: new Date().toISOString().split("T")[0],
                          message: "Future date is not allowed",
                        },
                      })}
                      error={!!errorsBasic?.dateOfBirth}
                      helperText={errorsBasic?.dateOfBirth?.message}
                    />
                  </Grid>
                  <Grid item lg={4} md={6} xs={12}>
                    <FormControl component="fieldset" error={!!errorsBasic.gender}>
                      <FormLabel className="text-dark" component="legend">
                        Your Gender<span style={{ color: "red" }}>*</span>
                      </FormLabel>
                      <Controller
                        name="gender"
                        control={BasicContact}
                        defaultValue=""
                        rules={{ required: "Please select your gender" }}
                        render={({ field }) => (
                          <RadioGroup row {...field}>
                            <FormControlLabel
                              value="0"
                              control={<Radio />}
                              label="Male"
                            />
                            <FormControlLabel
                              value="1"
                              control={<Radio />}
                              label="Female"
                            />
                            <FormControlLabel
                              value="3"
                              control={<Radio />}
                              label="Transgender"
                            />
                          </RadioGroup>
                        )}
                      />
                      {errorsBasic.gender && (
                        <FormHelperText>{errorsBasic.gender.message}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>



                </Grid>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2, mt: 3 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button type="submit" variant="contained" className="menus-color">
                    Update
                  </Button>
                </Box>
              </form>
            )}
          </div>

        </Box>
      )}
      {/* Student Contact Details */}
      <>
        {key === "contact" && (
          <Box>
            <div className="pt-1 pb-3">
              <div className="p-0">
                <div className="Architects-header d-flex align-items-center justify-content-center">
                  <h2 className="title-font text-center">Contact Details</h2>
                </div>
              </div>
            </div>
            <div className="p-md-5 p-3 overallPadding">
              <div className="text-end mb-3">
                <Button
                  onClick={() => window.history.back()}
                  variant="contained"
                  className="menus-color"
                >
                  Back
                </Button>
              </div>

              {loading ? (
                <Spinner />
              ) : (
                <form
                  className="mt-2"
                  onSubmit={handleSubmitContact((data) => UpdateStudentMemberContact(data, id))}
                >
                  <Grid container rowSpacing={3} columnSpacing={2}>
                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Address <span style={{ color: "red" }}>*</span></Typography>}
                        {...registerContact("address", {
                          required: "Please Enter an Address",
                          maxLength: {
                            value: 160,
                            message: 'Address must be less than or equal to 160 characters'
                          }
                        })}
                        error={!!errorsContact?.address}
                        helperText={errorsContact?.address?.message}
                        placeholder="Address"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Mobile Number <span style={{ color: "red" }}>*</span></Typography>}
                        {...registerContact("mobileNumber", {
                          required: "Please Enter a Mobile Number",
                          pattern: {
                            value: /^\d{10}$/,
                            message: "Mobile number must be 10 digits",
                          },
                        })}
                        error={!!errorsContact?.mobileNumber}
                        helperText={errorsContact?.mobileNumber?.message}
                        placeholder="Mobile Number"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">City/Town <span style={{ color: "red" }}>*</span></Typography>}
                        {...registerContact("city", { required: "Please Enter a City/Town" })}
                        error={!!errorsContact?.city}
                        helperText={errorsContact?.city?.message}
                        placeholder="City/Town"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">WhatsApp Number <span style={{ color: "red" }}>*</span></Typography>}
                        {...registerContact("whatsAppNumber", {
                          required: "Please Enter a WhatsApp Number",
                          pattern: {
                            value: /^\d{10}$/,
                            message: "Whatsapp number must be 10 digits",
                          },
                        })}
                        error={!!errorsContact?.whatsAppNumber}
                        helperText={errorsContact?.whatsAppNumber?.message}
                        placeholder="WhatsApp Number"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">PIN Code <span style={{ color: "red" }}>*</span></Typography>}
                        {...registerContact("pinCode", {
                          required: "Please Enter a PIN Code",
                          pattern: {
                            value: /^\d{6}$/,
                            message: "Pincode must be 6 digits",
                          },
                        })}
                        error={!!errorsContact?.pinCode}
                        helperText={errorsContact?.pinCode?.message}
                        placeholder="PIN Code"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Email Address <span style={{ color: "red" }}>*</span></Typography>}
                        {...registerContact("email", {
                          required: "Please Enter an Email",
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Enter a valid email ID",
                          },
                        })}
                        error={!!errorsContact?.email}
                        helperText={errorsContact?.email?.message}
                        placeholder="Email Address"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <FormControl fullWidth margin="normal" className="mt-0" error={!!errorsContact.state}>
                        <InputLabel variant="outlined" data-shrink="true">State <span style={{ color: "red" }}>*</span></InputLabel>
                        <Controller
                          name="state"
                          control={controlContact}
                          defaultValue=""
                          rules={{ required: selectedCountry ? "State is required" : false }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              labelId="state"
                              label={
                                <Typography className="text-dark">
                                  state
                                </Typography>
                              }
                              value={selectedState}
                              onChange={(e) => {
                                setSelectedState(e.target.value);
                                field.onChange(e);
                              }}
                              variant="outlined"
                            >
                              {states.map((state) => (
                                <MenuItem key={state.isoCode} value={state.name}>
                                  {state.name}
                                </MenuItem>
                              ))}
                            </Select>
                          )}

                        />
                        {errorsContact.state && <FormHelperText>{errorsContact.state.message}</FormHelperText>}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <FormControl fullWidth margin="normal" className="mt-0" error={!!errorsContact.country}>
                        <InputLabel>Country <span style={{ color: "red" }}>*</span></InputLabel>
                        <Controller
                          name="country"
                          control={controlContact}
                          defaultValue=""
                          rules={{ required: "Country is required" }}
                          render={({ field }) => (
                            <Select
                              labelId="Country"
                              label={
                                <Typography className="text-dark">
                                  Country
                                </Typography>
                              }
                              {...field}
                              value={selectedCountry}
                              onChange={(e) => {
                                setSelectedCountry(e.target.value);
                                field.onChange(e);
                              }}
                              variant="outlined"
                            >
                              {countries.map((country) => (
                                <MenuItem key={country.isoCode} value={country.isoCode}>
                                  {country.name}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                          disabled
                        />
                        {errorsContact.country && <FormHelperText>{errorsContact.country.message}</FormHelperText>}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ type: "number" }}
                        fullWidth
                        label={<Typography className="text-dark">Telephone Number </Typography>}
                        {...registerContact("landlineNumber")}
                        placeholder="Telephone Number"
                      />
                    </Grid>

                    {/* <Grid item xs={12} md={6} lg={4}>
                          <Controller
                            control={controlContact}
                            name="contactInformation"
                            render={({ field, fieldState }) => (
                              <Autocomplete
                                multiple
                                id="contactInformation"
                                fullWidth
                                options={ContactInformationVisibility}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option?.name}
                                filterSelectedOptions
                                onChange={(event, values) => {
                                  const selectedValues = Array.isArray(values) ? values : [];
                                  const contactInfoNames = selectedValues.map((value) => value?.name);
                                  field.onChange(contactInfoNames);
                                }}
                                value={
                                  field.value ?
                                    ContactInformationVisibility.filter((info) => field.value.includes(info.name)) : []
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    error={!!fieldState?.error}
                                    helperText={fieldState?.error?.message}
                                    label={<Typography className="text-dark">Contact Information Visibility</Typography>}
                                    placeholder="Select Contact Information Visibility"
                                  />
                                )}
                              />
                            )}
                          />
                        </Grid> */}
                  </Grid>
                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2, mt: 3 }}>
                    <Box sx={{ flex: "1 1 auto" }} />
                    <Button type="submit" variant="contained" className="menus-color">
                      Update
                    </Button>
                  </Box>
                </form>
              )}
            </div>
          </Box>
        )}
      </>

      {/* Student Academic Profile Links */}
      <>
        {key === "academic" && (
          <>
            <Box>
              <div className='pt-1 pb-3'>
                <div className='p-0'>
                  <div className='Architects-header d-flex align-items-center justify-content-center'>
                    <h2 className='title-font text-center'>Academic Profile Links</h2>
                  </div>
                </div>
              </div>
            </Box>
            <div className="p-md-5 p-3 overallPadding">
              <div className="text-end mb-3">
                <Button
                  onClick={() => window.history.back()}
                  variant="contained"
                  className="menus-color"
                >
                  Back
                </Button>
              </div>
              {loading ? (
                <Spinner />
              ) : (
                <form className="mt-2" onSubmit={handleSubmitAcademic((data) => UpdateStudentMemberAcademic(data, id))}>
                  <Grid container rowSpacing={3} columnSpacing={2}>
                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your Google Scholar Profile</Typography>}
                        {...registerAcademic("scholarProfile", {
                          pattern: {
                            value:
                              /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[\w .-]*)*\/?$/,
                            message: "Please enter a valid google scholar profile",
                          },
                        })
                        }
                        error={!!errorsAcademic?.scholarProfile}
                        helperText={errorsAcademic?.scholarProfile?.message}
                        placeholder="Google Scholar Profile"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your Scopus Profile Link</Typography>}
                        {...registerAcademic("scopusProfileLink", {
                          pattern: {
                            value:
                              /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[\w .-]*)*\/?$/,
                            message: "Please enter a valid scopus profile link",
                          },
                        })}
                        error={!!errorsAcademic?.scopusProfileLink}
                        helperText={errorsAcademic?.scopusProfileLink?.message}
                        placeholder="Scopus Profile Link"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your ORICID Id</Typography>}
                        {...registerAcademic("ORICID")}
                        error={!!errorsAcademic?.ORICID}
                        helperText={errorsAcademic?.ORICID?.message}
                        placeholder="ORICID Id"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your LinkedIn Profile</Typography>}
                        {...registerAcademic("linkedInProfile", {
                          pattern: {
                            value:
                              /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[\w .-]*)*\/?$/,
                            message: "Please enter a valid linkedIn profile",
                          },
                        })}
                        error={!!errorsAcademic?.linkedInProfile}
                        helperText={errorsAcademic?.linkedInProfile?.message}
                        placeholder="LinkedIn Profile"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your Blog/Website</Typography>}
                        {...registerAcademic("blog", {
                          pattern: {
                            value:
                              /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[\w .-]*)*\/?$/,
                            message: "Please enter a valid website /blog address",
                          },
                        })}
                        error={!!errorsAcademic?.blog}
                        helperText={errorsAcademic?.blog?.message}
                        placeholder="Blog/Website"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Your Youtube Channel</Typography>}
                        {...registerAcademic("youtubeChannel")}
                        error={!!errorsAcademic?.youtubeChannel}
                        helperText={errorsAcademic?.youtubeChannel?.message}
                        placeholder="Youtube Channel"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <FormControl fullWidth margin="normal" className="mt-0" error={!!errorsAcademic.shareInformation}>
                        <FormLabel component="legend">Consent To Share Information</FormLabel>
                        <Controller
                          name="shareInformation"
                          control={controlAcademic}
                          defaultValue=""
                          render={({ field }) => (
                            <RadioGroup
                              {...field}
                              row
                              onChange={(e) => field.onChange(e.target.value)}
                            >
                              <FormControlLabel value="1" control={<Radio />} label="Yes" />
                              <FormControlLabel value="0" control={<Radio />} label="No" />
                            </RadioGroup>
                          )}
                        />
                        {errorsAcademic.shareInformation && (
                          <FormHelperText>{errorsAcademic.shareInformation.message}</FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2, mt: 3 }}>
                    <Box sx={{ flex: "1 1 auto" }} />
                    <Button type="submit" variant="contained" className="menus-color">
                      Update
                    </Button>
                  </Box>
                </form>
              )}
            </div>
          </>
        )}
      </>

      {/* Student Educational Details */}
      <>
        {key === "education" && (
          <>
            <Box>
              <div className="pt-1 pb-3">
                <div className="p-0">
                  <div className="Architects-header d-flex align-items-center justify-content-center">
                    <h2 className="title-font text-center">Educational Details</h2>
                  </div>
                </div>
              </div>
            </Box>
            <div className="p-md-5 p-3 overallPadding">
              <div className="text-end mb-3">
                <Button
                  onClick={() => window.history.back()}
                  variant="contained"
                  className="menus-color"
                >
                  Back
                </Button>
              </div>

              {loading ? (
                <Spinner />
              ) : (
                <form className="mt-2" onSubmit={handleSubmitEducation((data) => UpdateStudentMemberEducation(data, id))}>
                  <Grid container rowSpacing={3} columnSpacing={2}>
                    <Grid item xs={12} md={6} lg={4}>
                      <Controller
                        control={controlEducation}
                        name="studying"
                        rules={{
                          required: 'Please select what you are studying at present',
                        }}
                        render={({ field, fieldState }) => (
                          <>
                            <FormControl fullWidth error={!!fieldState.error}>
                              <InputLabel className="text-dark">
                                What Are You Studying At Present?
                                <span style={{ color: "red" }}>*</span>
                              </InputLabel>
                              <Select
                                style={{ backgroundColor: "#f0f0f0" }}
                                label={<Typography className="text-dark">What Are You Studying At Present?</Typography>}
                                value={field.value}
                                variant="outlined"
                                onChange={(event, values) => {
                                  const selectedValue = event.target.value;
                                  field.onChange(selectedValue);
                                  const isOther = selectedValue === Qualifications.find(option => option.label === 'Other').id;
                                  setShowStudyingOtherInput(isOther);
                                  // If 'Other' is selected, clear the 'otherPrimarily' value
                                  if (isOther) {
                                    setOtherStudying('');
                                  }
                                }}
                                renderValue={(selected) => {
                                  const selectedOption = Qualifications.find((option) => option.id === selected);
                                  return selectedOption ? selectedOption.label : 'Select Studying At Present';
                                }}
                              >
                                {Qualifications.map((option) => (
                                  <MenuItem key={option.id} value={option.id}>
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </Select>
                              {fieldState?.error && !showStudyingOtherInput && (
                                <FormHelperText error>
                                  {fieldState.error.message}
                                </FormHelperText>
                              )}
                            </FormControl>

                            {/* Conditionally render input for "Other" option */}
                            {showStudyingOtherInput && (
                              <Controller
                                name="otherStudying"
                                control={controlEducation}
                                rules={{
                                  required: showStudyingOtherInput ? 'Please specify the other studying' : false,
                                }}
                                render={({ field: otherField, fieldState: otherFieldState }) => (
                                  <>
                                    <TextField
                                      fullWidth
                                      label={<Typography className="text-dark">Please specify</Typography>}
                                      placeholder="Specify other studying"
                                      variant="outlined"
                                      margin="normal"
                                      value={otherStudying}
                                      onChange={(e) => {
                                        otherField.onChange(e.target.value);
                                        setOtherStudying(e.target.value);
                                      }}
                                      error={!!otherFieldState.error}
                                      helperText={otherFieldState.error?.message}
                                    />
                                  </>
                                )}
                              />
                            )}
                          </>
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <Controller
                        control={controlEducation}
                        name="eligibilityExamination"
                        render={({ field, fieldState }) => (
                          <>
                            <Autocomplete
                              multiple
                              id="eligibilityExamination"
                              fullWidth
                              limitTags={2}
                              options={EligibilityExaminations}
                              disableCloseOnSelect
                              getOptionLabel={(option) => option?.name}
                              filterSelectedOptions
                              onChange={(event, values) => {
                                const selectedValues = Array.isArray(values) ? values : [];
                                const contactInfoIds = selectedValues.map((value) => value?.name);
                                // If "Other" is removed, clear the 'otherEligibility' value
                                if (!selectedValues.some((value) => value?.name === 'Other')) {
                                  setOtherEligibility('');  // Reset the "Other" input value
                                }
                                setShowEligibilityOtherInput(selectedValues.some((value) => value?.name === 'Other'));
                                field.onChange(contactInfoIds);
                              }}
                              value={
                                Array.isArray(field.value) ?
                                  EligibilityExaminations.filter((info) => field.value.includes(info.name)) : []
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={!!fieldState?.error}
                                  helperText={fieldState?.error?.message}
                                  label={
                                    <Typography className="text-dark overflow-hidden text-nowrap" style={{ textOverflow: "ellipsis" }}>
                                      Have You Got Through Any Eligibility Examinations?
                                    </Typography>
                                  }
                                />
                              )}
                            />

                            {/* Conditionally render input for "Other" option */}
                            {showEligibilityOtherInput && (
                              <Controller
                                name="otherEligibility"
                                control={controlEducation}
                                rules={{
                                  required: 'Please specify your other eligibility studies',
                                }}
                                render={({ field, fieldState }) => (
                                  <TextField
                                    fullWidth
                                    label={<Typography className="text-dark">Please specify</Typography>}
                                    placeholder="Specify other eligibility studies"
                                    variant="outlined"
                                    margin="normal"
                                    value={otherEligibility}
                                    error={!!fieldState.error} // Show error if fieldState has an error
                                    helperText={fieldState.error?.message} // Display the error message
                                    onChange={(e) => {
                                      handleOtherEligibilityChange(e); // Update state for external handling (if needed)
                                      field.onChange(e.target.value); // Update field value
                                    }}
                                  />
                                )}
                              />
                            )}
                          </>
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Name Of Your Institution<span style={{ color: "red" }}>*</span></Typography>}
                        {...registerEducation("institution", { required: "Please enter name of your institution" })}
                        error={!!errorsEducation?.institution}
                        helperText={errorsEducation?.institution?.message}
                        placeholder="Name Of Your Institution"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={<Typography className="text-dark">Address Of Your Institution<span style={{ color: "red" }}>*</span></Typography>}
                        {...registerEducation("institutionCity", { required: "Please enter name of your institution" })}
                        error={!!errorsEducation?.institutionCity}
                        helperText={errorsEducation?.institutionCity?.message}
                        placeholder="Address Of Your Institution"
                      />
                    </Grid>

                  </Grid>
                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2, mt: 3 }}>
                    <Box sx={{ flex: "1 1 auto" }} />
                    <Button type="submit" variant="contained" className="menus-color">
                      Update
                    </Button>
                  </Box>
                </form>
              )}
            </div>
          </>
        )}
      </>

      {/* Student Professional Development */}
      <>
        {key === "profession" && (
          <>
            <Box>
              <div className="pt-1 pb-3">
                <div className="p-0">
                  <div className="Architects-header d-flex align-items-center justify-content-center">
                    <h2 className="title-font text-center">Professional Development</h2>
                  </div>
                </div>
              </div>
            </Box>

            <div className="p-md-5 p-3 overallPadding">
              <div className="text-end mb-3">
                <Button
                  onClick={() => window.history.back()}
                  variant="contained"
                  className="menus-color"
                >
                  Back
                </Button>
              </div>
              {loading ? (
                <Spinner />
              ) : (
                <form className="mt-2" onSubmit={handleSubmitProfession((data) => UpdateStudentMemberProfession(data, id))}>
                  <Grid container rowSpacing={3} columnSpacing={2}>
                    <Grid item xs={12} md={6} lg={4}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend" className="text-dark">
                          Are you a member of any other Teachers’ Association?
                        </FormLabel>
                        <Controller
                          name="teacherAssociation"
                          control={controlProfession}
                          defaultValue="0"
                          render={({ field: { onChange, value } }) => (
                            <RadioGroup row value={value} onChange={onChange}>
                              <FormControlLabel value="1" control={<Radio />} label="Yes" />
                              <FormControlLabel value="0" control={<Radio />} label="No" />
                            </RadioGroup>
                          )}
                        />
                      </FormControl>

                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label={
                          <Typography className="text-dark">
                            If yes, mention the name of those associations
                          </Typography>
                        }
                        {...registerProfession("associationName", {
                          validate: (value) =>
                            isTeachersAsso === 1 && !value ? "Please mention the name of those associations" : true,
                        })}
                        placeholder="Mention The Name Of Those Associations"
                        disabled={isTeachersAsso === 0}
                        error={!!errorsProfession?.associationName}
                        helperText={errorsProfession?.associationName?.message}
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <Controller
                        control={controlProfession}
                        name="professionalDevelopment"
                        render={({ field, fieldState }) => (
                          <>
                            <Autocomplete
                              multiple
                              id="professionalDevelopment"
                              fullWidth
                              limitTags={1}
                              options={ProfessionalDevelopment}
                              disableCloseOnSelect
                              getOptionLabel={(option) => option?.name}
                              filterSelectedOptions
                              onChange={(event, values) => {
                                const selectedValues = Array.isArray(values) ? values : [];
                                const contactInfoIds = selectedValues.map((value) => value?.name);
                                // Reset the otherProfession input when "Other" is selected
                                if (!selectedValues.some((value) => value?.name === 'Other')) {
                                  setOtherProfession('');  // Reset the "Other" input value
                                }
                                const isOtherSelected = selectedValues.some((value) => value?.name === 'Other');
                                setShowProfessionOtherInput(isOtherSelected);
                                field.onChange(contactInfoIds);
                              }}
                              value={
                                field.value ?
                                  ProfessionalDevelopment.filter((info) => field.value.includes(info.name)) : []
                              }
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  {/* <Checkbox style={{ marginRight: 8 }} checked={selected} /> */}
                                  {option.name}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={!!fieldState?.error}
                                  helperText={fieldState?.error?.message}
                                  label={
                                    <Typography className="text-dark overflow-hidden text-nowrap" style={{ textOverflow: "ellipsis" }}>
                                      Which of the following would you like to do for your continuous professional development?
                                    </Typography>
                                  }
                                />
                              )}
                            />

                            {/* Conditionally render input for "Other" option */}
                            {showProfessionOtherInput && (
                              <Controller
                                name="otherProfession"
                                control={controlProfession}
                                rules={{
                                  required: 'Please specify your other professional studies',
                                }}
                                render={({ field, fieldState }) => (
                                  <TextField
                                    fullWidth
                                    label={<Typography className="text-dark">Please specify</Typography>}
                                    placeholder="Specify other professional studies"
                                    variant="outlined"
                                    margin="normal"
                                    value={otherProfession}
                                    error={!!fieldState.error} // Show error if fieldState has an error
                                    helperText={fieldState.error?.message} // Display the error message
                                    onChange={(e) => {
                                      handleOtherProfessionChange(e); // Update state for external handling (if needed)
                                      field.onChange(e.target.value); // Update field value
                                    }}
                                  />
                                )}
                              />
                            )}
                          </>
                        )}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <h2 className="menus-green-color">Your Areas of Expertise:</h2>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <Controller
                        control={controlProfession}
                        name="expertiseLiteraryStudies"
                        render={({ field, fieldState }) => (
                          <>
                            <Autocomplete
                              multiple
                              id="expertiseLiteraryStudies"
                              fullWidth
                              limitTags={1}
                              options={LiteraryStudies}
                              disableCloseOnSelect
                              getOptionLabel={(option) => option?.name}
                              filterSelectedOptions
                              onChange={(event, values) => {
                                const selectedValues = Array.isArray(values) ? values : [];
                                const contactInfoIds = selectedValues.map((value) => value?.name);
                                const isOtherSelected = selectedValues.some((value) => value?.name === 'Other');
                                setShowLiteraryOtherInput(isOtherSelected);
                                field.onChange(contactInfoIds);
                                // Reset the otherLit input when "Other" is selected
                                if (!selectedValues.some((value) => value?.name === 'Other')) {
                                  setOtherLit('');  // Reset the "Other" input value
                                }
                              }}
                              value={
                                field.value ?
                                  LiteraryStudies.filter((info) => field.value.includes(info.name)) : []
                              }
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  {/* <Checkbox style={{ marginRight: 8 }} checked={selected} /> */}
                                  {option.name}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={!!fieldState?.error}
                                  helperText={fieldState?.error?.message}
                                  label={<Typography className="text-dark">Literary Studies</Typography>}
                                />
                              )}
                            />

                            {/* Conditionally render input for "Other" option */}
                            {showLiteraryOtherInput && (
                              <Controller
                                name="otherLit"
                                control={controlProfession}
                                rules={{
                                  required: 'Please specify your other literary studies',
                                }}
                                render={({ field, fieldState }) => (
                                  <TextField
                                    fullWidth
                                    label={<Typography className="text-dark">Please specify</Typography>}
                                    placeholder="Specify other literary studies"
                                    variant="outlined"
                                    margin="normal"
                                    value={otherLit}
                                    error={!!fieldState.error} // Show error if fieldState has an error
                                    helperText={fieldState.error?.message} // Display the error message
                                    onChange={(e) => {
                                      field.onChange(e.target.value); // Update field value
                                      handleOtherLitChange(e); // Update state for external handling (if needed)
                                    }}
                                  />
                                )}
                              />
                            )}
                          </>
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <Controller
                        control={controlProfession}
                        name="expertiseLinguistics"
                        render={({ field, fieldState }) => (
                          <>
                            <Autocomplete
                              multiple
                              id="expertiseLinguistics"
                              fullWidth
                              options={Linguistics}
                              disableCloseOnSelect
                              limitTags={1}
                              getOptionLabel={(option) => option?.name}
                              filterSelectedOptions
                              onChange={(event, values) => {
                                const selectedValues = Array.isArray(values) ? values : [];
                                const contactInfoIds = selectedValues.map((value) => value?.name);
                                field.onChange(contactInfoIds);
                                const isOtherSelected = selectedValues.some((value) => value?.name === 'Other');
                                setShowLinguisticsOtherInput(isOtherSelected);
                                field.onChange(contactInfoIds);
                                // Reset the otherLing input when "Other" is selected
                                if (!selectedValues.some((value) => value?.name === 'Other')) {
                                  setOtherLing('');  // Reset the "Other" input value
                                }
                              }}
                              value={
                                field.value ?
                                  Linguistics.filter((info) => field.value.includes(info.name)) : []
                              }
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  {/* <Checkbox style={{ marginRight: 8 }} checked={selected} /> */}
                                  {option.name}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={!!fieldState?.error}
                                  helperText={fieldState?.error?.message}
                                  label={<Typography className="text-dark">Linguistics</Typography>}
                                />
                              )}
                            />

                            {/* Conditionally render input for "Other" option */}
                            {showLinguisticsOtherInput && (
                              <Controller
                                name="otherLing"
                                control={controlProfession}
                                rules={{
                                  required: 'Please specify your other linguistics studies',
                                }}
                                render={({ field, fieldState }) => (
                                  <TextField
                                    fullWidth
                                    label={<Typography className="text-dark">Please specify</Typography>}
                                    placeholder="Specify other linguistics studies"
                                    variant="outlined"
                                    margin="normal"
                                    value={otherLing}
                                    error={!!fieldState.error} // Show error if fieldState has an error
                                    helperText={fieldState.error?.message} // Display the error message
                                    onChange={(e) => {
                                      field.onChange(e.target.value); // Update field value
                                      handleOtherLingChange(e); // Update state for external handling (if needed)
                                    }}
                                  />
                                )}
                              />
                            )}
                          </>
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <Controller
                        control={controlProfession}
                        name="expertiseELT"
                        render={({ field, fieldState }) => (
                          <>
                            <Autocomplete
                              multiple
                              limitTags={1}
                              id="expertiseELT"
                              fullWidth
                              options={EnglishLanguageTeaching}
                              disableCloseOnSelect
                              getOptionLabel={(option) => option?.name}
                              filterSelectedOptions
                              onChange={(event, values) => {
                                const selectedValues = Array.isArray(values) ? values : [];
                                const contactInfoIds = selectedValues.map((value) => value?.name);
                                const isOtherSelected = selectedValues.some((value) => value?.name === 'Other');
                                setShowELTOtherInput(isOtherSelected);
                                field.onChange(contactInfoIds);
                                // Reset the otherELT input when "Other" is selected
                                if (!selectedValues.some((value) => value?.name === 'Other')) {
                                  setOtherELT('');  // Reset the "Other" input value
                                }
                              }}
                              value={
                                field.value ?
                                  EnglishLanguageTeaching.filter((info) => field.value.includes(info.name)) : []
                              }
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  {/* <Checkbox
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                      /> */}
                                  {option.name}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={!!fieldState?.error}
                                  helperText={fieldState?.error?.message}
                                  label={
                                    <Typography className="text-dark">
                                      English Language Teaching (ELT)
                                    </Typography>
                                  }
                                />
                              )}
                            />

                            {/* Conditionally render input for "Other" option */}
                            {showELTOtherInput && (
                              <Controller
                                name="otherELT"
                                control={controlProfession}
                                rules={{
                                  required: 'Please specify your other ELT studies',
                                }}
                                render={({ field, fieldState }) => (
                                  <TextField
                                    fullWidth
                                    label={<Typography className="text-dark">Please specify</Typography>}
                                    placeholder="Specify other ELT studies"
                                    variant="outlined"
                                    margin="normal"
                                    value={otherELT}
                                    error={!!fieldState.error} // Show error if fieldState has an error
                                    helperText={fieldState.error?.message} // Display the error message
                                    onChange={(e) => {
                                      field.onChange(e.target.value); // Update field value
                                      handleOtherELTChange(e); // Update state for external handling (if needed)
                                    }}
                                  />
                                )}
                              />
                            )}
                          </>
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <Controller
                        control={controlProfession}
                        name="expertiseInterdisciplinaryAreas"
                        render={({ field, fieldState }) => (
                          <>
                            <Autocomplete
                              multiple
                              id="expertiseInterdisciplinaryAreas"
                              fullWidth
                              limitTags={1}
                              options={InterdisciplinaryAreas}
                              disableCloseOnSelect
                              getOptionLabel={(option) => option?.name}
                              filterSelectedOptions
                              onChange={(event, values) => {
                                const selectedValues = Array.isArray(values) ? values : [];
                                const contactInfoIds = selectedValues.map((value) => value?.name);
                                const isOtherSelected = selectedValues.some((value) => value?.name === 'Other');
                                setShowInterOtherInput(isOtherSelected);
                                field.onChange(contactInfoIds);
                                // Reset the otherInter input when "Other" is selected
                                if (!selectedValues.some((value) => value?.name === 'Other')) {
                                  setOtherInter('');  // Reset the "Other" input value
                                }
                              }}
                              value={
                                field.value ?
                                  InterdisciplinaryAreas.filter((info) => field.value.includes(info.name)) : []
                              }
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  {/* <Checkbox
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                      /> */}
                                  {option.name}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={!!fieldState?.error}
                                  helperText={fieldState?.error?.message}
                                  label={
                                    <Typography className="text-dark">
                                      Interdisciplinary Areas
                                    </Typography>
                                  }
                                />
                              )}
                            />

                            {/* Conditionally render input for "Other" option */}
                            {showInterOtherInput && (
                              <Controller
                                name="otherInter"
                                control={controlProfession}
                                rules={{
                                  required: 'Please specify your other interdisciplinary areas',
                                }}
                                render={({ field, fieldState }) => (
                                  <TextField
                                    fullWidth
                                    label={<Typography className="text-dark">Please specify</Typography>}
                                    placeholder="Specify other interdisciplinary areas"
                                    variant="outlined"
                                    margin="normal"
                                    value={otherInter}
                                    error={!!fieldState.error} // Show error if fieldState has an error
                                    helperText={fieldState.error?.message} // Display the error message
                                    onChange={(e) => {
                                      field.onChange(e.target.value); // Update field value
                                      handleOtherInterChange(e); // Update state for external handling (if needed)
                                    }}
                                  />
                                )}
                              />
                            )}
                          </>
                        )}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <h2 className="menus-green-color">Areas of Expertise:</h2>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend">
                          Are you willing
                          to have your areas of interest listed
                          publicly so that other members can
                          identify potential collaboration
                          opportunities?
                        </FormLabel>
                        <Controller
                          name="areaOfExpertise"
                          control={controlProfession}
                          defaultValue=""
                          render={({ field }) => (
                            <RadioGroup row {...field}>
                              <FormControlLabel value="1" control={<Radio />} label="Yes" />
                              <FormControlLabel value="0" control={<Radio />} label="No" />
                            </RadioGroup>
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2, mt: 3 }}>
                    <Box sx={{ flex: "1 1 auto" }} />
                    <Button type="submit" variant="contained" className="menus-color">
                      Update
                    </Button>
                  </Box>
                </form>
              )}
            </div>

          </>
        )}
      </>
    </>
  );
}

export default Profile;